// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"716330f6","117":"caf2d77f","257":"bee00f03","277":"c050f70f","596":"f2cb6c90","608":"9c2fcfbc","881":"63702c67","920":"19b6883e"}[chunkId] + ".chunk.js";
};